<template>
    <div class="IETips">
        <DetailsNav></DetailsNav>
        <div class="labNav">
            <img src="../../assets/IETips.png" width="402px" alt=""/>
        </div>
        <div class="font">微软已宣布停止IE浏览器的支持，打开有风险。 建议使用其他浏览器打开~</div>
    </div>
</template>
<script>
import DetailsNav from "./../components/detailsNav.vue";
export default({
  components: {
    DetailsNav,
  }
})
</script>

<style lang="scss" scoped>
.IETips{
    height: 100vh;
    background: #fff;
    .labNav{
        margin: auto 0;
        text-align: center;
        padding-top: 26vh;
        line-height: 50px;
    }
    .font{
        max-width: 550px;
        height: 147px;
        opacity: 1;
        font-size: 26px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #19232b;
        line-height: 55px;
        margin: auto;
        margin-top: 30px;
    }
}
</style>